<template>
    <div class="md-layout-item md-medium-size-75 md-xsmall-size-100 md-size-50 p-2">
        <stats-card data-background-color="green">
            <template slot="header">
                <md-icon>draw</md-icon>
            </template>

            <template slot="content">
                <div class="loader" v-if="loading"></div>
                <div v-else>
                    <h5 class="category">{{ $t('signing.unfinished') }}</h5>
                    <h4 class="title">{{myCount}}</h4>
                </div>
            </template>

            <template slot="footer">
                <div class="stats row col-12">
                    <div class="col-6">
                        <span>
                            <md-icon class="text-success">details</md-icon>
                            <a href="#" @click.stop="goToMine">
                            {{ $t('my') }}<span class="badge badge-success ml-2">{{ myCount }}</span>
                            </a>
                        </span>
                    </div>
                    <div class="col-6 text-right">
                        <span v-if="claims.tasks.read">
                            <md-icon class="text-success">details</md-icon>
                            <a href="#" @click.stop="goToAll">
                            {{ $t('all') }}<span class="badge badge-info ml-2">{{ allCount }}</span>
                            </a>
                        </span>
                    </div>
                </div>
            </template>
        </stats-card>
    </div>
</template>

<script>
    import StatsCard from "@/components/cards/StatsCard";
    import { mapGetters } from 'vuex';

    export default {
        name: 'UnfinishedSigningStats',
        components: {
            'stats-card': StatsCard
        },
        data() {
            return {
                loaded: false,
                loading: false,
                myCount: '',
                allCount: ''
            }
        },
        methods: {
            loadSigningCount() {
                this.loading = true;
                this.$http.get(this.getApiUrl())
                .then(result => {
                    this.myCount = Number(result.data.myCount)
                    this.allCount = Number(result.data.allCount)
                }).catch(error => {

                }).then(() => {
                    this.loading = false;
                    this.loaded = true;
                });
            },
            goToMine() {
                this.$router.push({ path: '/signatures' });
            },
            goToAll() {
                if (!this.claims.tasks.read) {
                    return this.$router.push('/unauthorized');
                }

                this.$router.push({ path: '/administration/signatures' });
            },
            getApiUrl() {
                return '/api/signing/unfinishedCount';
            },
        },
        mounted() {
            this.loadSigningCount();
        },
        computed: {
            ...mapGetters(['claims'])
        },
        created() {
            this.$tasksHub.$on('signing-add-updated', this.loadSigningCount);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.$tasksHub.$off('signing-add-updated', this.loadSigningCount);
        },
    }
</script>
